


















































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import PosTicketTable from '@modules/pos/components/tables/pos-ticket-table/pos-ticket-table.vue';
import PosContactSummary from '@modules/pos/components/v2/pos-contact-summary.vue';
import BpcPosTicketDetail from '@pos/components/v2/pos-ticket-detail.vue';
import BpcPosPaymentList from '@pos/components/v2/pos-payment-list.vue';
import BpcHtmlToPrinter from '@shared/components/html-to-printer/html-to-printer.vue';
import PosPrintTicket from '@modules/pos/components/v2/pos-print-ticket.vue';

import {
  POSContact,
  POSPayment,
  POSPaymentMethod,
  POSProductTypeData,
  POSTicket,
  POSTicketDetail,
  POSTicketView,
} from '@pos/interfaces/pos-v2';

@Component({
  name: 'bpc-pos-search-ticket-modal',
  components: {
    'bpc-pos-ticket-table': PosTicketTable,
    'bpc-pos-contact-summary': PosContactSummary,
    'bpc-pos-ticket-detail': BpcPosTicketDetail,
    'bpc-pos-payment-list': BpcPosPaymentList,
    'bpc-pos-print-ticket': PosPrintTicket,
    BpcHtmlToPrinter,
  },
  mixins: [],
})
export default class PosSearchTicketModal extends Vue {
  $refs!: {
    htmlToPrinter: InstanceType<typeof BpcHtmlToPrinter> & {
      printContent: () => void;
    };
    htmlBarcodeToPrinter: InstanceType<typeof BpcHtmlToPrinter> & {
      printContent: () => void;
    };
  };
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({
    type: Number,
    required: true,
  })
  readonly posSessionId!: number;
  @Prop({ type: Array, required: true }) readonly paymentMethodOptions: POSPaymentMethod[];
  @Prop({ type: String, default: 'print' }) readonly printButtonIcon: string;

  // DATA
  public filterConfigName = 'pos-ticket-filters';
  public filtersExcluded = ['type'];
  public tableTitle = 'global.models.ticket.heading';
  public tableSubtitle = 'global.models.ticket.subheading';
  public extendedFilterConfigName = '';
  public displayConfigName = 'pos-search-tickets-table';
  public formConfigName: string = 'create-ticket-form';
  public sendInvoiceAction: boolean = false;

  // Data for ticket view modal
  public posViewTicketModalTitle: string = 'Titulo';
  public showViewTicketModal: boolean = false;
  public currentTicket: POSTicket = null;
  public currentContact: POSContact = null;
  public currentTicketDetail: POSTicketDetail = null;
  public ticketProductTypes: POSProductTypeData[] = [];
  public ticketPayments: POSPayment[] = [];
  public showPrintTicketBlockedWindowModal = false;
  public contact = null;

  // COMPUTED
  get currentTicketId(): number {
    return this.currentTicket?.id;
  }

  get currentContactId(): number {
    return this.currentContact?.id;
  }

  get currentTicketStatusIsPaid() {
    return this.currentTicket?.status === 'paid';
  }
  // LIFECYCLE
  // METHODS

  closeModal() {
    this.restartValues();
    this.$emit('close');
  }

  async printTicket() {
    await this.$nextTick();
    await this.$refs.htmlToPrinter.printContent();
  }

  restartValues(): void {
    return;
  }

  onPaymentMethodTypeUpdated() {
    this.$emit('payment-method-type-updated');
  }

  async onReopenTicket() {
    const ticketDetail = await this.$posService.reopenTicket(
      this.posSessionId,
      this.currentTicketId,
    );
    this.$emit('reopen-ticket', ticketDetail);
    this.showViewTicketModal = false;
  }

  async loadTicketAndPrint(ticket) {
    await this.getTicketDetail(ticket.id, ticket.pos_session.id);
    this.currentTicket = { ...ticket, can_be_marked_as_paid: false };
    this.contact = this.currentTicketDetail.contact;
    this.$nextTick(() => {
      this.printTicket();
    });
  }

  onPrintTicket(ticket: POSTicketDetail) {
    this.currentTicketDetail = ticket;
    this.contact = this.currentTicketDetail.contact;
    this.$nextTick(() => {
      this.printTicket();
    });
  }

  openTicket(ticket: POSTicket) {
    this.$emit('open-ticket', ticket);
  }

  async viewTicket(ticket: POSTicketView) {
    await this.getTicketDetail(ticket.id, ticket.pos_session.id);
    this.currentTicket = { ...ticket, can_be_marked_as_paid: false };
    const ticketStringForTitle = this.$t('global.ticket.label');
    const sessionStringForTitle = this.$t('global.pos_session.code_and_contact.label');
    const formatedDate = this.$bpcHelper.formatDate(ticket.invoice_date);
    this.posViewTicketModalTitle = `${ticketStringForTitle} ${ticket.code} - ${formatedDate} - ${sessionStringForTitle}: ${ticket.pos_session.code_and_contact} `;
    this.showViewTicketModal = true;
  }

  async getTicketDetail(ticketId: number, posSessionId: number) {
    const ticketDetail: POSTicketDetail = await this.$posService.getTicketDetail(
      posSessionId,
      ticketId,
    );

    this.refreshTicketDetail(ticketDetail);
  }

  onCheckoutTicket($event: POSTicket) {
    this.$emit('checkout-ticket', $event);
  }

  refreshTicketDetail(ticketDetail: POSTicketDetail) {
    this.currentTicketDetail = ticketDetail;
    if (ticketDetail.contact) {
      this.currentContact = ticketDetail.contact;
    }
    if (ticketDetail.productTypes) {
      this.ticketProductTypes = ticketDetail.productTypes;
    }
    if (ticketDetail.payments) {
      this.ticketPayments = ticketDetail?.payments || [];
    }
  }

  onPrintTicketWindowBlocked() {
    this.showPrintTicketBlockedWindowModal = true;
  }

  // WATCHERS
}
